<div class="common-container__list-landing">
  <div class="concept-form__form-fields-container">
    <div class="common-section-title__gs-container-primary">
      <span class="common-section-title__gs-label-text">
        {{proceduresText}}
      </span>
    </div>
    <div class="common-container__centered-inner-search-container w-[50%]">
      <div class="common-search__container-tonal">
        <div class="common-search__container-input-text">
          <input
            type="search"
            class="common-search__input-text"
            [(ngModel)]="conceptList.searchText"
            (input)="applyAllFilters()"
            placeholder="{{'common.search-item' | afTranslate}}"
          />
        </div>
        <div class="common-search__block-button-search">
          @if (conceptList.searchText) {
            <button
              class="common-button__icon-xs-noborder"
              (click)="conceptList.searchText = '';applyAllFilters()">
              <i aria-hidden="true" class="lf-icon-close-thick common-icon__sm">
              </i>
            </button>
          }
          <div
            [ngClass]="{
              'common-divider__vertical-main-1000': conceptList.searchText,
              'common-divider__vertical-grey-400': !conceptList.searchText
            }"
            class="h-[22px]">
          </div>
          <i
            [ngClass]="{
              'common-search__icon-search-enabled': conceptList.searchText,
              'common-button__icon-sm-noborder--disabled': !conceptList.searchText
            }"
            class="lf-icon-search common-icon__md">
          </i>
        </div>
      </div>
    </div>
  </div>
  <div class="concept-list__landing">
    <div class="common-table__container">
      <div class="common-table-header__container">
        <div class="common-table-body__inner-row w-[calc(100%-30px)]">
          <div class="common-table-cell__container w-[30%]">
            <filter-by-search-and-order
              [item]="conceptList.titleFilter"
              [filterOrder]="conceptList.filterOrder"
              [order]="conceptList.order"
              (launchActionFilterOrderEmit)="onFilterChange($event, 'title')">
            </filter-by-search-and-order>
          </div>
          <div class="common-table-cell__container w-[17.5%]">
            <filter-by-search-and-order
              [item]="conceptList.referenceFilter"
              [filterOrder]="conceptList.filterOrder"
              [order]="conceptList.order"
              (launchActionFilterOrderEmit)="onFilterChange($event, 'referenceId')">
            </filter-by-search-and-order>
          </div>
          <div class="common-table-cell__container w-[17.5%]">
            <filter-by-dates-and-order
              [item]="conceptList.creationDateQueryFilter"
              [filterOrder]="conceptList.filterOrder"
              [order]="conceptList.order"
              [dateFilter]="conceptList.creationDateFilter"
              (launchActionFilterOrderEmit)="onFilterChange($event, 'creationDate')">
            </filter-by-dates-and-order>
          </div>
          <div class="common-table-cell__container w-[17.5%]">
            <filter-by-dates-and-order
              [item]="conceptList.modificationDateQueryFilter"
              [filterOrder]="conceptList.filterOrder"
              [order]="conceptList.order"
              [dateFilter]="conceptList.modificationDateFilter"
              (launchActionFilterOrderEmit)="onFilterChange($event, 'modificationDate')">
            </filter-by-dates-and-order>
          </div>
          <div class="common-table-cell__container w-[17.5%]">
            <filter-by-list-and-order
              [item]="conceptList.stepFilter"
              [list]="conceptList.stepList"
              [filterOrder]="conceptList.filterOrder"
              [order]="conceptList.order"
              (launchActionFilterOrderEmit)="onFilterChange($event, 'step')">
            </filter-by-list-and-order>
          </div>
        </div>
      </div>
      <div id="table-concept-list-landing"
      class="common-table-body__container max-h-[460px]">
        @for (evaluateConcept of conceptList.conceptListFilter | afOrderBy:conceptList.filterOrder:conceptList.order | afLimitTo:conceptList.configPagination.itemsPerPage:conceptList.configPagination.firstElement; track $index) {
          <div class="common-table-body__row">
            <div
              (click)="openConcept(evaluateConcept)"
              class="common-table-body__inner-row w-[calc(100%-30px)]">
              <div class="common-table-cell__container w-[30%]">
                <span-tooltip
                  class="common-table-cell__standard-text-label"
                  [text]="evaluateConcept.title">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[17.5%]">
                <span-tooltip
                  class="common-table-cell__standard-text-label"
                  [text]="evaluateConcept.referenceId">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[17.5%]">
                <span-tooltip
                  class="common-table-cell__standard-text-label"
                  [text]="evaluateConcept.creationDate | convertDate:''">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[17.5%]">
                <span-tooltip
                  class="common-table-cell__standard-text-label"
                  [text]="evaluateConcept.modificationDate | convertDate:''">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[17.5%]">
                <span-tooltip
                  class="common-table-cell__standard-text-label"
                  [text]="evaluateConcept.step">
                </span-tooltip>
              </div>
            </div>
            <div class="common-table-cell__container-actions justify-end w-[30px]">
              <button
                (click)="openConcept(evaluateConcept, true)"
                class="common-button__icon-md-noborder">
                <i aria-hidden="true" class="common-icon__md lf-icon-open-window">
                </i>
              </button>
            </div>
          </div>
        } @empty {
          <div
            class="common-empty-state__message-container"
            afTranslate="box-queries.no-queries">
            _No hay consultas
          </div>
        }
      </div>
    </div>
    <pagination-control
      [config]="conceptList.configPagination"
      [totalRecords]="conceptList.conceptListFilter?.length"
      [containerTableId]="'table-concept-list-landing'"
      (currentPageChange)="changeCurrentPage($event)">
    </pagination-control>
  </div>
</div>
